/**
 * useQueryWarehouseOverview — TanStack Query bilan SWR-style caching.
 */
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../config/queryKeys';
import { getWarehouseOverview, getWarehouseOverviewFromTenants } from '../services/warehouseApi';

export function useQueryWarehouseOverview(params) {
  const query = useQuery({
    queryKey: queryKeys.warehouseOverview(params || {}),
    queryFn: async () => {
      const safeParams = params || {};
      // getWarehouseOverview endi barcha rollar uchun /api/warehouse/overview ga murojaat qiladi,
      // tenant_owner/cashier uchun xato bo'lsa getWarehouseOverviewFromTenants fallback ishga tushadi.
      const data = await getWarehouseOverview(safeParams);
      return Array.isArray(data) ? data : [];
    },
    select: (data) => (Array.isArray(data) ? data : []),
    enabled: !params?._skip,
    staleTime: 90_000,
    gcTime: 15 * 60 * 1000,
  });
  return {
    data: query.data ?? [],
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
